require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-packages-social-media-management-2-channels.json") })
        }
      }, "path---services-packages-social-media-management-2-channels");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-packages-social-media-management-2-channels!./.cache/json/services-packages-social-media-management-2-channels.json
// module id = 753
// module chunks = 231608221292675